import React from 'react';
import { Grid, Text, Divider, Box } from '@spothero/ui';
import { textStyle } from './OversizeRefund';
import FormatUtils from 'utils/format';
const RefundBreakdown = ({ children, amountCharged, discountAmount, spotheroCreditUsed, originalRentalPrice, oversizeAmount, }) => {
    const oversizeFormatted = FormatUtils.price(oversizeAmount).displayPrice;
    const originalPriceFormatted = FormatUtils.price(originalRentalPrice - oversizeAmount).displayPrice;
    const totalChargedFormatted = FormatUtils.price(amountCharged).displayPrice;
    const discountUsedFormatted = FormatUtils.price(discountAmount)
        .displayPrice;
    const creditUsedFormatted = FormatUtils.price(spotheroCreditUsed)
        .displayPrice;
    return (<>
            <Box paddingX={3} paddingY={2} marginBottom={6} backgroundColor="green.100" borderRadius="md">
                <Text lineHeight="1.4">
                    Your new vehicle selection isn&apos;t oversized, so
                    you&apos;ll be refunded the fee you&apos;ve already paid.
                </Text>
            </Box>
            <Grid gap={2} width="100%" templateColumns="2fr 1fr" marginBottom={6}>
                <Text {...textStyle}>Original Price:</Text>
                <Text justifySelf="end" {...textStyle}>
                    ${originalPriceFormatted}
                </Text>
                <Text {...textStyle} color="black">
                    Oversize Fee:
                </Text>
                <Text justifySelf="end" {...textStyle} color="black">
                    ${oversizeFormatted}
                </Text>
                {spotheroCreditUsed > 0 && (<>
                        <Text {...textStyle}>SpotHero Credit:</Text>
                        <Text justifySelf="end" {...textStyle}>
                            -${creditUsedFormatted}
                        </Text>
                    </>)}
                {discountAmount > 0 && (<>
                        <Text {...textStyle}>Promotion Code:</Text>
                        <Text justifySelf="end" {...textStyle}>
                            -${discountUsedFormatted}
                        </Text>
                    </>)}
                <Divider gridColumn="1/3" width="100%" color="gray.100"/>
                <Text {...textStyle}>Total Previously Paid:</Text>
                <Text justifySelf="end" {...textStyle}>
                    ${totalChargedFormatted}
                </Text>

                {children}
            </Grid>
        </>);
};
export default RefundBreakdown;
